module.exports = __webpack_public_path__ + "static/media/smartpoint.61f5392e.png";